import { CircularProgress, Box } from '@mui/material';

export const Loading = () => {
  return (
    <Box
      display="flex"
      height="100dvh"
      width="100vw"
      alignItems="center"
      justifyContent="center"
    >
      <CircularProgress />
    </Box>
  );
};
